import { IQuestionModel } from '@care-portals/api-interfaces';

const questionsModels: IQuestionModel[] = [
  /**
   * Promo-Hair forms
   */
  {
    label: 'Please select your preference of Finasteride:',
    field: 'phlPref',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'topical', value: 'Topical' },
        { key: 'tablets', value: 'Tablets' }
      ]
    }
  }
];

export default questionsModels;
